const CONSTANTES ={
    URL_API:'https://nacinalferreteradehidalgo.space',
    // URL_API:'http://142.93.19.134:8000',
    // URL_API:'http://127.0.0.1:8000',
    GET_CONFIG:'GET_CONFIG',
    PUT_CONFIG:'PUT_CONFIG', 
    INICIAR_SESION:'INICIAR_SESION',
    ESTABLECER_SESION:'ESTABLECER_SESION',
    CHECK_USER:'CHECK_USER',
    LOGOUT_USER:'LOGOUT_USER',
    GET_USUARIO:'GET_USUARIO',
    OBTENER_USUARIO:'OBTENER_USUARIO',
    CERRAR_SESION:'CERRAR_SESION',
    ESTABLECER_CIERRE:'ESTABLECER_CIERRE',
    GET_ORDENES:'GET_ORDENES', 
    PUT_ORDENES:'PUT_ORDENES',
    FILTRO_ORDENES:'FILTRO_ORDENES',
    GET_ORDEN:'GET_ORDEN',
    PUT_ORDEN:'PUT_ORDEN',
    GET_DETAIL_ORDEN:'GET_DETAIL_ORDEN',
    PUT_DETAIL_ORDEN:'PUT_DETAIL_ORDEN',
    GET_HISTORIAL_ORDEN:'GET_HISTORIAL_ORDEN',
    OBTENER_HISTORIAL_ORDEN:'OBTENER_HISTORIAL_ORDEN',

    REVISAR_ORDEN:'REVISAR_ORDEN',
    PUT_REVISAR_ORDEN:'PUT_REVISAR_ORDEN',
    
    GET_USUARIOS:'GET_USUARIOS',
    OBTENER_USUARIOS:'OBTENER_USUARIOS',
    REGISTRO_USUARIO:'REGISTRO_USUARIO',
    ADD_USUARIO:'ADD_USUARIO',

    EDITAR_USUARIO:'EDITAR_USUARIO',
    EDIT_USUARIO:'EDIT_USUARIO',
    
    ELIMINAR_USUARIO:'ELIMINAR_USUARIO',

    GET_CATEGORIAS:'GET_CATEGORIAS',
    PUT_CATEGORIAS:'PUT_CATEGORIAS',
    AGREGAR_CATEGORIA:'AGREGAR_CATEGORIA',
    ADD_CATEGORIA:'ADD_CATEGORIA',

    GET_CATALOGO:'GET_CATALOGO',
    PUT_CATALOGO:'PUT_CATALOGO',
    AGREGAR_PRODUCTO:'AGREGAR_PRODUCTO',
    ADD_PRODUCTO:'ADD_PRODUCTO',
    EDITAR_PRODUCTO:'EDITAR_PRODUCTO',
    EDIT_PRODUCTO:'EDIT_PRODUCTO',


    GET_CLIENTES:'GET_CLIENTES',
    PUT_CLIENTES:'PUT_CLIENTES',
    PUT_CLIENTE:'PUT_CLIENTE',
    GET_DETAIL_CLIENTE:'GET_DETAIL_CLIENTE',
    PUT_DETAIL_CLIENTE:'PUT_DETAIL_CLIENTE',
    REGISTRO_CLIENTE:'REGISTRO_CLIENTE',
    ADD_CLIENTE:'ADD_CLIENTE',
    EDITAR_CLIENTE:'EDITAR_CLIENTE',
    EDIT_CLIENTE:'EDIT_CLIENTE',


    GET_PRODUCTS:'GET_PRODUCTS',
    GET_PRODUCTS_SUCCESS:'GET_PRODUCTS_SUCCESS',

    FILTER_PRODUCTS:'FILTER_PRODUCTS',

    GET_PRODUCTS_DETAIL_SUCCESS:'GET_PRODUCTS_DETAIL_SUCCESS',
    GET_PRODUCT_DETAIL:'GET_PRODUCT_DETAIL',
    
    ADD_PRODUCT:'ADD_PRODUCT',
    ADD_PRODUCT_SUCCESS:'ADD_PRODUCT_SUCCESS',

    UPDATE_PRODUCT:'UPDATE_PRODUCT',
    UPDATE_PRODUCT_SUCCESS:'UPDATE_PRODUCT_SUCCESS',

    OPEN_NEW_MODAL_PRODUCT:'OPEN_NEW_MODAL_PRODUCT',
    CLOSE_NEW_MODAL_PRODUCT:'CLOSE_NEW_MODAL_PRODUCT',
    OPEN_EDIT_MODAL_PRODUCT:'OPEN_EDIT_MODAL_PRODUCT',
    CLOSE_EDIT_MODAL_PRODUCT:'CLOSE_EDIT_MODAL_PRODUCT',

    GET_CONFIG_TARIFAS:'GET_CONFIG_TARIFAS',
    GET_CONFIG_TARIFAS_SUCCESS:'GET_CONFIG_TARIFAS_SUCCESS',

    EDIT_TARIFAS_REQUEST:'EDIT_TARIFAS_REQUEST',
    EDIT_TARIFAS_REQUEST_SUCCESS:'EDIT_TARIFAS_REQUEST_SUCCESS',
    EDIT_TARIFAS_REQUEST_ERROR:'EDIT_TARIFAS_REQUEST_ERROR',

    GET_FILES_PRODUCTS_REQUEST:'GET_FILES_PRODUCTS_REQUEST',
    GET_FILES_PRODUCTS_SUCCESS:'GET_FILES_PRODUCTS_SUCCESS',
    GET_FILES_PRODUCTS_ERROR:'GET_FILES_PRODUCTS_ERROR',

    ADD_PRODUCT_FILE_REQUEST:'ADD_PRODUCT_FILE_REQUEST',
    ADD_PRODUCT_FILE_SUCCESS:'ADD_PRODUCT_FILE_SUCCESS',
    ADD_PRODUCT_FILE_ERROR:'ADD_PRODUCT_FILE_ERROR',

    EDIT_PRODUCT_FILE_REQUEST:'EDIT_PRODUCT_FILE_REQUEST',
    EDIT_PRODUCT_FILE_SUCCESS:'EDIT_PRODUCT_FILE_SUCCESS',
    EDIT_PRODUCT_FILE_ERROR:'EDIT_PRODUCT_FILE_ERROR',

    DELETE_PRODUCT_FILE_REQUEST:'DELETE_PRODUCT_FILE_REQUEST',
    DELETE_PRODUCT_FILE_SUCCESS:'DELETE_PRODUCT_FILE_SUCCESS',
    DELETE_PRODUCT_FILE_ERROR:'DELETE_PRODUCT_FILE_ERROR',
}

export default CONSTANTES
